import * as z from "zod";

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Expected YYYY-MM-DD");

/**
 * HSA adoption rate for the authenticated team over a date range, from the
 * DBT.ATTACHMENT.HSA_ATTACHMENT warehouse mart (refreshed every few hours).
 */
export const getHsaAdoptionRate = {
  name: "getHsaAdoptionRate" as const,
  input: z.object({ startDate: isoDate, endDate: isoDate }),
  output: z.object({
    /** Orders paid with a Gale HSA/FSA payment method. */
    paidOrders: z.number(),
    /** Orders containing at least one HSA/FSA-eligible item. */
    eligibleOrders: z.number(),
    /** paidOrders / eligibleOrders; null when there were no eligible orders. */
    adoptionRate: z.number().nullable(),
  }),
};
